import {blueColor, greenColor, orangeColor, purpleColor} from "../../../components/header/HeaderData";


export const quizData = [
    {
        color: greenColor,
        number: "1.",
        description: 'Odpowiedz na 3 pytania o czynnościowe zaburzenia jelit i meweberyny.',

    },
    {
        color: orangeColor,
        number: "2.",
        description: 'Tylko jedna odpowiedź jest prawidłowa.',

    },
    {
        color: purpleColor,
        number: "3.",
        description: 'Po zaznaczeniu odpowiedz i kliknięciu DALEJ nie ma możliwości powrotu do wcześniejszego pytania.',

    },
    {
        color: blueColor,
        number: "4.",
        description: 'Wyślij formularz zgłoszeniowy do quizu.',

    }
];